import React, { memo } from 'react';
import WaitingForIncidentMessage from '../shared/IncidentWidgets/WaitingForIncidentMessage';
import { connect } from 'react-redux';
import { selectCurrentDisplayedIncident } from '../../../../state/modules/incidents/selectors';
import { sortBy } from 'lodash';
import { ListGroup } from '../../../ui-kit';
import { TimeAgo } from '../../../../utils/time';

// To test
//
// incident = FactoryBot.create(:incident, tasks: [Group.find(44).tasks.first])
// incident.activity_report_notes.create(contents: Faker::Lorem.sentence, timestamp: Time.zone.now)
const IncidentNotes = ({ displayedIncident }) => {
  if (!displayedIncident) return <WaitingForIncidentMessage />;
  // sort order on timestamp
  const notes = sortBy(displayedIncident.notes || [], ['timestamp', 'id']);
  return (
    <ListGroup>
      {notes.length === 0 && (
        <ListGroup.Item>
          <i>{I18n.t('no_results_found')}</i>
        </ListGroup.Item>
      )}
      {notes.map(n => (
        <ListGroup.Item key={n.id}>
          <h3>{n.contents}</h3>
          <small>
            <TimeAgo timestamp={n.timestamp} />
          </small>
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
};

// way of adding a static SettingsContent variable to a functional component
Object.assign(IncidentNotes, {
  defaultSettings: { defaultAutoScrollEnabled: true }
});

const mapStateToProps = state => ({
  displayedIncident: selectCurrentDisplayedIncident(state)
});

export default connect(mapStateToProps)(memo(IncidentNotes));
